import styled from "@emotion/styled";
import SquareRoundedIcon from "@mui/icons-material/SquareRounded";
// common both info and jobinfo page
export const InfoMainContainer = styled("div")({
  // padding: "20px",
  // borderRadius: "10px",
  // border:"1px solid #d6d6d6",
});
export const StyledInfoTabs =styled("div")({
  cursor: "pointer",
  background: "var(--accordian-background)",
  padding: "10px 20px",
  borderRadius: "8px",
  marginTop: "20px",
  marginBottom: "20px",
  fontWeight: "bold",
  color: "var(--accordian-text)",
  border: "1px solid var(--accordian-border)",
})
export const StyledInfoUpdate = styled("div")({
  display: "flex",
  gap: "35px",
  padding: "10px 20px",
  borderBottom: "1px solid var(--accordian-border)",
  "@media screen and (max-width:835px)": {
    gap: "80px",
  },
});
export const StyledEmployerDetails = styled("div")({
  display: "flex",
  gap: "20px",
  flexDirection: "row",
  marginBottom: "25px",
  padding: "10px",
  borderBottom: "1px solid var(--accordian-border)",
  position: "relative",
  "@media screen and (max-width:835px)": {
    flexDirection: "column",
    gap: "0",
  },
});

export const StyledEmployerCertification = styled("div")({
  height: "auto",
  display: "flex",
  flexDirection: "row",
  columnGap: "10px",
  padding: "0px 20px",
  position: "relative",
  "&:not(:first-of-type)::before": {
    content: "''",
    position: "absolute",
    left: 0,
    width: "1px",
    height: "60%",
    backgroundColor: "#e6e5f4",
    margin: "10px 0px",
  },
  "@media (max-width: 835px)": {
    "&:not(:first-of-type)::before": {
      content: "none",
    },
    padding: "0px 10px",
    columnGap: "90px",
  },
});
export const StyledEmployerCompany = styled("div")({
  height: "auto",
  display: "flex",
  flexDirection: "row",
  columnGap: "10px",
  padding: "0px 10px",
  "@media (max-width: 835px)": {
    columnGap: "55px",
  },
});
export const InfoLowerContainer = styled("div")({
  height: "auto",
});


export const InfoLabel = styled("p")({
  color: "var(--text-color-accent)",
  fontWeight: "500",
  fontSize: "14px",
  margin: "0",
});

export const PersonalInfoGrid = styled("div")({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "0",
  "@media screen and (max-width: 992px)": {
    gridTemplateColumns: "1fr",
  },
});

export const PersonalInfoLabel = styled("p")({
  color: "var(--text-color-accent)",
  fontWeight: "500",
  fontSize: "14px",
  margin: "0",
  "@media screen and (max-width:991px)": {
    width: "100px",
  },
});
export const InfoValue = styled("div")({
  fontSize: "14px",
  fontWeight: "500",
  color: "var(--header__color)",
});
export const InfoMail = styled("p")({
  margin: "0",
});
export const InfoNumber = styled("p")({
  fontSize: "14px",
  fontWeight: "500",
  color: "#000000",
});
export const InfoHeader = styled("h3")({
  fontWeight: "600",
  fontSize: "16px",
  color: "var(--header__color)",
});
export const InfoName = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});
export const InfoText = styled("p")({
  color: "#6860EE",
  fontSize: "16px",
  fontWeight: "500",
});
export const InfoTime = styled("p")({});
export const RecuriteNoteMainDiv = styled("div")({
  padding: "10px 20px",
});

export const RecuriteNoteDiv = styled("div")({
  padding: "10px 20px",
});
export const RecruiterNotes = styled("p")({
  fontSize: "14px",
  fontWeight: "400",
  color: "#000000",
});
export const JobDescription = styled("p")({
  fontSize: "14px",
  fontWeight: "400",
  color: "#000000",
});

export const StyledImageIcon = styled(SquareRoundedIcon)({
  width: "30px",
  height: "30px",
  marginRight: "25px",
  color: "#ccc",
});
export const RecruiterDetails = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  borderBottom: "1px solid #DDDDDD",
  boxShadow: "0px 4px 10px 0px #0000000D",
  padding: "0px 16px",
});
export const StyledImage = styled("img")({
  width: "30px",
  height: "30px",
  cursor: "pointer",
});

// info page style
export const StyledPersonalInfoSkillDiv = styled("div")({
  display: "flex",
  gap: "50px",
  flexDirection: "row",
  borderBottom: "1px solid var(--accordian-border)",
  padding: "10px 20px",
  "@media screen and (max-width:835px)": {
    gap: "20px",
  },
});
export const StyledPersonalInfoDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  borderBottom: "1px solid var(--accordian-border)",
  padding: "10px 20px",
});
export const StyledPersonalInfoContentDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  gap: "10px",
  position: "relative",
  alignItems: "center",
  "&:not(:first-of-type)::before": {
    content: "''",
    position: "absolute",
    left: "-10px",
    width: "1px",
    height: "60%",
    backgroundColor: "#e6e5f4",
    margin: "10px 0px",
  },
  "@media (max-width: 991px)": {
    "&:not(:first-of-type)::before": {
      content: "none",
    },
    gap: "20px",
  },

  "@media (max-width: 768px)": {
    flexDirection: "column",
    alignItems: "flex-start",
  },
});

export const CandidateContentLabelDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  gap: "10px",
});


export const PersonalInfoContentMainDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  // gap: "50px",
  justifyContent: "space-between",
  marginRight: "20%",
  "@media screen and (max-width:1200px)": {
    flexDirection: "row",
    marginRight: "0%",
  },
  "@media screen and (max-width:768px)": {
    flexDirection: "column",
    gap: "10px",
    marginRight: "0%",
  },
});
export const InfoContentMainDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  // gap: "50px",
  justifyContent: "flex-start",
  // marginRight: "20%",
  gap:"20px",
  "@media screen and (max-width:1200px)": {
    flexDirection: "row",
    marginRight: "0%",
  },
  "@media screen and (max-width:991px)": {
    flexDirection: "column",
    marginRight: "0%",
  },
  "@media screen and (max-width:768px)": {
    flexDirection: "column",
    gap: "10px",
    marginRight: "0%",
  },
});
export const RecuriterNoteContainerDiv = styled("div")({
  boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.1)",
  border: "1px solid #DDDDDDDD",
  borderRadius: "8px",
  margin: "20px 0px 0px 0px",
});
export const ContentDetailsMainDiv = styled("div")({
  display: "flex",
  flexDirection: "column",
  borderBottom: "1px solid var(--accordian-border)",
  padding: "10px 20px",
});

export const ContentDetailsInnerDiv = styled("div")({
  display: "flex",
  gap: "50px",
  flexDirection: "row",
  alignItems: "center",
  "@media screen and (max-width:768px)": {
    gap: "20px",
  },
  "@media screen and (max-width:660px)": {
    gap: "10px",
  },
});
export const ContentInfoDetailsInnerDiv = styled("div")({
  display: "flex",
  gap: "50px",
  flexDirection: "row",
  alignItems: "center",
  "@media screen and (max-width:991px)": {
    flexDirection: "column",
    gap: "10px",
    alignItems: "flex-start",
  },
  // "@media screen and (max-width:660px)": {
  //   gap: "30px",
  // },
});
export const ContentDetailsInfoInnerDiv = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "10px",
});
export const ContentDetailsInfoWrapperDiv = styled("div")({
  display: "flex",
  gap: "20px",
  "@media screen and (max-width:991px)": {
    flexDirection: "column",
    gap: "0",
  },
});
export const ContentMailIconActive = styled("img")({
  width: "25px",
});
export const ContentMobileIconActive = styled("img")({ width: "25px" });
export const ContentTimeIconActive = styled("img")({ width: "25px" });
export const ContentDetailsInnerSecondDiv = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "90px",
  "@media screen and (max-width:768px)": {
    gap: "60px",
  },
  "@media screen and (max-width:660px)": {
    gap: "50px",
  },
});
export const ContentInfoDetailsInnerSecondDiv = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "90px",
  "@media screen and (max-width:991px)": {
    gap: "20px",
  },
  "@media screen and (max-width:660px)": {
    gap: "20px",
  },
});
export const SocialMediaDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "Center",
  gap: "10px",
  padding: "10px",
  borderBottom: "1px solid var(--accordian-border)",
});
export const RecuriterNoteMainDiv = styled("div")({
  padding: "10px 10px",
});
export const DocumentDownloadDiv = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "20px",
  borderBottom: "1px solid var(--accordian-border)",
  padding: "10px",
});
export const DocumentDownloadInnerDiv = styled("div")({
  display: "flex",
  flexDirection: "row",
  columnGap: "10px",
});

export const Date = styled("div")({
  fontSize: "14px",
  color: "var(--header__color)",
  whiteSpace: "nowrap",
});
